import { Component, input, Input, OnDestroy, OnInit, output } from '@angular/core';

import { Icon, IconType } from 'app/shared/icon';

@Component({
    selector: 'stby-snackbar',
    templateUrl: './snackbar.html',
    styleUrl: './snackbar.scss',
    imports: [Icon],
})
export class Snackbar implements OnInit, OnDestroy {
    @Input() title: string;
    @Input() content?: string;
    @Input() icon?: IconType;
    @Input() iconFill?: string;
    @Input() duration: number = 5000;

    readonly dismissFn = input<() => void>(() => {});

    readonly animationDone = output<'enter' | 'leave'>();

    dismissed = false;

    onAnimationEnd(event: AnimationEvent): void {
        if (event.animationName === 'snackbarOut') {
            this.animationDone.emit('leave');
        } else if (event.animationName === 'snackbarIn') {
            this.animationDone.emit('enter');
        }
    }

    private timeoutHandle: any;
    private startTime: number = 0;
    private remainingTime: number;

    ngOnInit(): void {
        if (this.duration > 0) {
            this.remainingTime = this.duration;
            this.startTimer();
        }
    }

    ngOnDestroy(): void {
        clearTimeout(this.timeoutHandle);
    }

    pause(): void {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
            const elapsed = Date.now() - this.startTime;
            this.remainingTime -= elapsed;
        }
    }

    resume(): void {
        if (this.remainingTime > 0) {
            this.startTimer();
        }
    }

    dismiss(): void {
        this.dismissed = true;
    }

    public resetTimer(): void {
        if (this.timeoutHandle) {
            clearTimeout(this.timeoutHandle);
        }

        this.remainingTime = this.duration;
        this.startTimer();
    }

    private startTimer(): void {
        this.startTime = Date.now();
        this.timeoutHandle = setTimeout(() => {
            this.dismiss();
        }, this.remainingTime);
    }
}
